module.exports = __webpack_public_path__ + "media/career/overview-photo-c0e785c8.webp";